import React, { Component } from 'react';

class Banner extends Component {

    componentDidMount() {
        if (this.props.doAnimate) {
            //todo
        }
    }

    getClassNames() {
        let classNames = 'banner';

        if (this.props.newClass)
            classNames += ' ' + this.props.newClass;

        return classNames;
    }

    render() {
        return (
            <section className={this.getClassNames()}>
                <div className="row">
                    <div className="col-xs-12">
                        <span
                            className="animate"
                            dangerouslySetInnerHTML={{__html: this.props.title}}
                            ref={el => this.bannerRef = el}
                        />
						{this.props.children}
                    </div>
                </div>
            </section>
        );
    }

}

export default Banner;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Banner.js